import React, { useCallback, useEffect, useState } from "react";
import { Container, Col, Row, Form, InputGroup, FormFloating } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { showAlert } from "../../redux/slices/alertSlice";
import { insertCollaborator } from "../../redux/slices/collaboratorSlice";

import "../../assets/css/forms.css";
import ducksGroupImg from "../../assets/images/ducksGroup.svg";
import { ChevronDownIcon, ChevronLeftIcon } from "../../components/Icon/icons";
import Icon from "../../components/Icon/Icon";
import IconButton from "../../components/IconButton/IconButton";
import ButtonSpinner from "../../components/UI/ButtonSpinner/ButtonSpinner";
import FormAlert from "../../components/UI/FormAlert/FormAlert";
import Subheader from "../../components/UI/Subheader/Subheader";

function CollaboratorRegisterScreen() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [team, setTeam] = useState({});
  const [seniority, setSeniority] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);

  const dispatch = useDispatch();
  const collaboratorSlice = useSelector((state) => state.collaboratorSlice);
  const teamSlice = useSelector((state) => state.teamSlice);
  const senioritySlice = useSelector((state) => state.senioritySlice);

  const navigate = useNavigate();
  const goToHome = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const handleShowAlert = useCallback(
    (alert) => {
      dispatch(showAlert(alert));
    },
    [dispatch]
  );

  const onChangeTeam = (e) => {
    const newTeam = teamSlice.teamList.find((s) => s.id === Number(e.target.value));
    setTeam(newTeam);
  };

  const onChangeSeniority = (e) => {
    const newSeniority = senioritySlice.seniorityList.find((s) => s.id === Number(e.target.value));
    setSeniority(newSeniority);
  };

  function handleSubmit(event) {
    event.preventDefault();
    dispatch(insertCollaborator({ name, email, teamId: team.id, seniorityId: seniority.id, isAdmin }));
    setIsSubmitted(true);
  }

  useEffect(() => {
    const canRedirect = isSubmitted && !collaboratorSlice.loading && !collaboratorSlice.error;
    if (canRedirect) {
      handleShowAlert({
        headingText: "Colaborador cadastrado!",
        text: "Colaborador cadastrado com sucesso!",
      });
      goToHome();
    }
  }, [
    dispatch,
    goToHome,
    handleShowAlert,
    isSubmitted,
    collaboratorSlice.collaboratorList,
    collaboratorSlice.error,
    collaboratorSlice.loading,
  ]);

  return (
    <>
      <Helmet>
        <title>Cadastro de Colaborador</title>
      </Helmet>
      <Subheader title="Colaboradores | Cadastro de Colaborador"></Subheader>

      <Container>
        <Row className="mb-3">
          <Col className="screen-header">
            <IconButton onClick={goToHome} className="icon-button-return">
              <ChevronLeftIcon />
            </IconButton>
            <h4 className="screen-header-title">Adicionar Colaborador</h4>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="registration-form">
              <h4>Adicionar dados</h4>

              <p>Insira abaixo, o nome e email do colaborador para completar o cadastro</p>

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="collaboratorName" className="mb-3">
                  <FormFloating>
                    <Form.Label>Nome</Form.Label>
                    <InputGroup>
                      <Form.Control
                        required
                        placeholder="Nome do colaborador"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </InputGroup>
                  </FormFloating>
                </Form.Group>

                <Form.Group controlId="collaboratorEmail" className="mb-3">
                  <FormFloating>
                    <Form.Label>E-mail</Form.Label>
                    <InputGroup>
                      <Form.Control
                        required
                        placeholder="E-mail do colaborador"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </InputGroup>
                  </FormFloating>
                </Form.Group>

                <Form.Group controlId="collaboratorTeam" className="mb-3">
                  <FormFloating>
                    <Form.Label>Time</Form.Label>
                    <InputGroup>
                      <Form.Control
                        required
                        as="select"
                        className="form-control-select"
                        value={team?.id}
                        onChange={onChangeTeam}
                      >
                        <option key={null} value={""}>
                          Selecione o time
                        </option>
                        {teamSlice.teamList.map((team) => (
                          <option key={team.id} value={team.id}>
                            {team.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Icon className="form-control-icon">
                        <ChevronDownIcon />
                      </Icon>
                    </InputGroup>
                  </FormFloating>
                </Form.Group>

                <Form.Group controlId="collaboratorSeniority" className="mb-3">
                  <FormFloating>
                    <Form.Label>Nível de Senioridade</Form.Label>
                    <InputGroup>
                      <Form.Control
                        required
                        as="select"
                        className="form-control-select"
                        value={seniority?.id}
                        onChange={onChangeSeniority}
                      >
                        <option key={null} value={""}>
                          Selecione a senioridade
                        </option>
                        {senioritySlice.seniorityList.map((seniority) => (
                          <option key={seniority.id} value={seniority.id}>
                            {seniority.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Icon className="form-control-icon">
                        <ChevronDownIcon />
                      </Icon>
                    </InputGroup>
                  </FormFloating>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="switch"
                    label="Administrador"
                    checked={isAdmin}
                    onChange={(e) => setIsAdmin(e.target.checked)}
                  />
                </Form.Group>

                <ButtonSpinner type="submit" isLoading={collaboratorSlice.loading}>
                  Cadastrar Colaborador
                </ButtonSpinner>
              </Form>
            </div>

            {collaboratorSlice.error && <FormAlert alertTextList={collaboratorSlice.error} />}
          </Col>
          <Col className="d-flex align-items-center">
            <img style={{ width: "100%", maxWidth: "450px" }} src={ducksGroupImg} alt="Ilustração" />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CollaboratorRegisterScreen;
